export default "__VITE_ASSET__D8PQhp7d__"